import React, { memo, Fragment } from 'react';
import { useIsVendastaAccount } from '@core/utils/hooks/misc/useSettings';
export interface NonVendastaContentProps {
  children: React.ReactNode;
}

export const NonVendastaContent = memo((props: NonVendastaContentProps) => {
  const isVendasta = useIsVendastaAccount();

  if (isVendasta) return null;
  return <Fragment>{props.children}</Fragment>;
});

export const VendastaContent = memo((props: NonVendastaContentProps) => {
  const isVendasta = useIsVendastaAccount();

  if (isVendasta) return <Fragment>{props.children}</Fragment>;
  return null;
});
